import React from 'react';
import { Section } from './ui/Section';
export function OpeningLead() {
  return <Section className="max-w-3xl mx-auto text-center" data-id="element-64">
      <div className="relative" data-id="element-65">
        <span className="absolute -top-8 left-0 text-8xl text-brand-primary/10 font-serif leading-none" data-id="element-66">
          “
        </span>
        <h2 className="text-2xl md:text-3xl font-serif leading-relaxed text-gray-700 italic relative z-10" data-id="element-67">
          Hay un momento que solo lo entiende quien lo vive.
        </h2>
      </div>

      <div className="mt-8 space-y-6 text-lg text-gray-600 leading-relaxed" data-id="element-68">
        <p data-id="element-69">
          Estás en medio de algo normal: una conversación, una fila, una
          reunión… y de golpe tu cuerpo{' '}
          <strong className="text-brand-primary font-medium" data-id="element-70">
            sube la temperatura
          </strong>{' '}
          como si alguien hubiera girado una perilla.
        </p>
        <p data-id="element-71">No es solo “calor”.</p>
        <p data-id="element-72">
          Es el cansancio, la irritación, el sueño roto… y esa sensación de que
          tu cuerpo{' '}
          <strong className="text-brand-primary font-medium" data-id="element-73">
            no te pide permiso
          </strong>
          .
        </p>
        <div className="w-16 h-1 bg-brand-accent/30 mx-auto my-8 rounded-full" data-id="element-74"></div>
        <p className="font-medium text-xl text-brand-text" data-id="element-75">
          Este ebook es para recuperar control sin convertir tu vida en un
          protocolo imposible.
        </p>
      </div>
    </Section>;
}